const attemptScoringRequest = function* (callback) {
  return yield callback()
}

export default attemptScoringRequest
